import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-standard-skeleton-table',
  templateUrl: './standard-skeleton-table.component.html',
  styleUrls: ['./standard-skeleton-table.component.scss'],
})
export class StandardSkeletonTableComponent {

  /**
   * headers: list of headers to be displayed: ['Name', 'Group', 'Country'].
   * tdAmount: number of <td> in table.
   * rowAmount: number of <tr> in table.
   * blankSpaceIndices: list of indexes with white spaces.
   */
  @Input() headers: string[];
  @Input() tdAmount: number;
  @Input() trAmount: number;
  @Input() blankSpaceIndices: number[] = [];
}

export interface SkeletonProps {
  headers?: string[];
  tdAmount?: number;
  trAmount?: number;
  blankSpaceIndices?: number[];
}
